<template>
     <img :src="require('@/assets/images/store/'+type+'.png')" alt="" :style="'width:'+size+'px;'+'height:'+size+'px'"  />
</template>
<script>
export default {
    name:"cIcon",
    props:{
        type:{
            type:String,
            default(){
                return 'spqs'
            }
        },
        size:{
            type:Number,
            default:function(){
                return 28
            }
        }
    }
}
</script>